function setSelected(s, value) {
	if (s) {
		Array.prototype.filter.call(s.options, ($option) => {
			if ($option.value === value) {
				$option.selected = "selected";
			}
		});
	}
}

function setSelectedForMultipleElements(list, value) {
	list.forEach(($option) => {
		setSelected($option, value);
	});
	return;
}

/**
 * Attempts to find a value in a select list using case-insensitive search
 * @param {any} s The HTMLSelectElement that contains the options
 * @param {any} value The value whos corresponding option value should be found (case insensitive)
 * @returns the value as defined by the matched option elements value. If no match could be made, an empty string is returned.
 */
function findSelectionValueCaseInsensitive(s, value) {
	if (!s || !s.options) {
		return "";
	}
	var optionElement = Array.prototype.find.call(s.options, ($option) => $option.value.toLowerCase() === value.toLowerCase());
	return optionElement && optionElement.value ? optionElement.value : "";
}

/**
 * Will populate the contents of a select
 * @param  {object} data response object from an ajax request
 * @param  {string} identifier The string identifier for an element
 * @param  {bool} clearAllButFirst Defines weather the select should be cleared from all but the first option before
 * @param  {bool} clearAll Defines weather the select should be cleared before
 */
function populateDropDown(data, identifier, clearAllButFirst, clearAll) {
	if (clearAllButFirst) {
		$("#" + identifier)
			.find("option")
			.not(":first")
			.remove();
	}

	if (clearAll) {
		$("#" + identifier)
			.find("option")
			.remove();
	}

	if (data !== null) {
		$.each(data, function (_key, value) {
			$("#" + identifier).append($("<option>", { value: value }).text(value));
		});
	}
}

export { setSelected, setSelectedForMultipleElements, populateDropDown, findSelectionValueCaseInsensitive };
